/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 333:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(900);
var Global = __webpack_require__(907);
var _require = __webpack_require__(649),
  get = _require.get;
var _require2 = __webpack_require__(190),
  settings = _require2.settings,
  pubadsReady = _require2.pubadsReady,
  pushAd = _require2.pushAd;
var loadGptScript = function loadGptScript() {
  if (Global.isLoadedGptScript) {
    return;
  }
  Global.isLoadedGptScript = true;
  var securepubadsScript = document.createElement('script');
  securepubadsScript.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
  securepubadsScript.async = true;
  document.head.appendChild(securepubadsScript);
};
var setGlobalGoogleAd = function setGlobalGoogleAd() {
  if (!Global.gptadslots) {
    Global.gptadslots = [];
  }
  if (!Global.googletag) {
    Global.googletag = {
      cmd: []
    };
  }
};
var refreshAdSlots = function refreshAdSlots(slotId) {
  var googletag = Global.googletag,
    gptadslots = Global.gptadslots;
  var node = document.querySelector("#".concat(slotId));
  var slotIndex = gptadslots.findIndex(function (slot) {
    return slot.id === node.id;
  });
  if (slotIndex > -1) {
    googletag.cmd.push(function () {
      googletag.pubads().setForceSafeFrame(true);
      googletag.pubads().refresh([gptadslots[parseInt(slotIndex, 10)].slot], {
        changeCorrelator: false
      });
      gptadslots.splice(slotIndex, 1);
    });
  }
};
var setPersonalDataAdsDenied = function setPersonalDataAdsDenied(personalDataAdsDenied, segmentation) {
  var cookie = get('personal_data_ads_denied');
  var isLoggedUserAdsDenied = segmentation.custID && personalDataAdsDenied;
  var isCookieExist = !segmentation.custID && cookie === 'true';
  var disablePersonalizedAds = isLoggedUserAdsDenied || isCookieExist;
  return disablePersonalizedAds;
};
var noUserSegmentation = function noUserSegmentation(personalDataAdsDenied, segmentation, userConsentCookie) {
  var googletag = Global.googletag;
  var disablePersonalizedAds = setPersonalDataAdsDenied(personalDataAdsDenied, segmentation);
  var shouldPersonalizedAds = !userConsentCookie || disablePersonalizedAds ? 1 : 0;
  googletag.pubads().setPrivacySettings({
    nonPersonalizedAds: shouldPersonalizedAds
  });
};
var loadGooglePublisherTag = function loadGooglePublisherTag(googleAd, slotId, handleStateAd, segmentation, personalDataAdsDenied, userConsentCookie) {
  var enabled = googleAd.enabled,
    size = googleAd.size,
    unit = googleAd.unit,
    ppid = googleAd.ppid,
    iframeTitle = googleAd.iframeTitle;
  var googletag = Global.googletag,
    gptadslots = Global.gptadslots;
  return new Promise(function (resolve) {
    if (enabled) {
      googletag.cmd.push(function () {
        settings(ppid, googletag, iframeTitle);
      }, function () {
        pubadsReady(googletag);
      }, function () {
        pushAd(googletag, unit, size, slotId, noUserSegmentation, personalDataAdsDenied, segmentation, gptadslots, handleStateAd, resolve, userConsentCookie);
      });
    }
  });
};
var loadAdCard = function loadAdCard(slotId, googleAd, handleStateAd, segmentationData, personalDataAdsDenied, userConsentCookie) {
  setGlobalGoogleAd();
  return loadGooglePublisherTag(googleAd, slotId, handleStateAd, segmentationData, personalDataAdsDenied, userConsentCookie).then(function () {
    refreshAdSlots(slotId);
  });
};
module.exports = {
  loadGptScript: loadGptScript,
  loadAdCard: loadAdCard,
  setGlobalGoogleAd: setGlobalGoogleAd,
  noUserSegmentation: noUserSegmentation
};

/***/ }),

/***/ 260:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var React = __webpack_require__(15);
var Global = __webpack_require__(907);
var _require = __webpack_require__(333),
  loadGptScript = _require.loadGptScript,
  loadAdCard = _require.loadAdCard;
var _require2 = __webpack_require__(625),
  trackMelidata = _require2.trackMelidata;

/* istanbul ignore next  */
var getAdServerObserver = function getAdServerObserver(platform, viewportMargin, slotId, googleAd, handleStateAd, segmentation, personalDataAdsDenied, userConsentCookie) {
  var googleObserver = new Global.IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        loadGptScript();
        loadAdCard(slotId, googleAd, handleStateAd, segmentation, personalDataAdsDenied, userConsentCookie);
        observer.disconnect();
      }
    });
  }, {
    rootMargin: viewportMargin && "".concat(viewportMargin, "px 0px") || (platform !== 'webmobile' ? '0px 0px 150px 0px' : '0px')
  });
  return googleObserver;
};

/* istanbul ignore next  */
var getTrackObserver = function getTrackObserver(melidataTrack) {
  var trackObserver = new Global.IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        trackMelidata(melidataTrack);
        observer.disconnect();
      }
    });
  }, {
    rootMargin: '-20px 0px'
  });
  return trackObserver;
};
var viewPortInterceptionObserver = function viewPortInterceptionObserver(viewportNode, observerAd) {
  observerAd.observe(viewportNode.current);
};
var trackInterceptionObserver = function trackInterceptionObserver(viewportNode, observerTrack) {
  observerTrack.observe(viewportNode.current);
};
var disconnectObservers = function disconnectObservers(observerAd, observerTrack) {
  if (observerAd) {
    observerAd.disconnect();
  }
  if (observerTrack) {
    observerTrack.disconnect();
  }
};
module.exports = {
  getAdServerObserver: getAdServerObserver,
  getTrackObserver: getTrackObserver,
  viewPortInterceptionObserver: viewPortInterceptionObserver,
  trackInterceptionObserver: trackInterceptionObserver,
  disconnectObservers: disconnectObservers
};

/***/ }),

/***/ 527:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(971)["default"]);
var _reactJsxRuntime = __webpack_require__(732);
var _slicedToArray = (__webpack_require__(826)["default"]);
var _BannerPreconnectScri, _BannerPreconnectScri2;
/* eslint-disable react/forbid-prop-types */
var React = __webpack_require__(15);
var classNames = __webpack_require__(892);
var Global = __webpack_require__(907);
var _require = __webpack_require__(715),
  getIsLowEndExperience = _require.getIsLowEndExperience;
var BannerPreconnectScript = __webpack_require__(444);
var _require2 = __webpack_require__(260),
  getAdServerObserver = _require2.getAdServerObserver,
  getTrackObserver = _require2.getTrackObserver,
  viewPortInterceptionObserver = _require2.viewPortInterceptionObserver,
  trackInterceptionObserver = _require2.trackInterceptionObserver,
  disconnectObservers = _require2.disconnectObservers;
var _require3 = __webpack_require__(333),
  loadGptScript = _require3.loadGptScript,
  loadAdCard = _require3.loadAdCard;
var useEffect = React.useEffect,
  useState = React.useState,
  Fragment = React.Fragment,
  createRef = React.createRef,
  useRef = React.useRef;
var Banner = function Banner(props) {
  var _useState = useState({
      show: false,
      loaded: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    stateAd = _useState2[0],
    setStateAd = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoadedAdCard = _useState4[0],
    setIsLoadedAdCard = _useState4[1];
  var viewportNode = createRef();
  var className = props.className,
    caption = props.caption,
    slotId = props.slotId,
    googleAd = props.googleAd,
    segmentation = props.segmentation,
    onAdLoad = props.onAdLoad,
    personalDataAdsDenied = props.personalDataAdsDenied,
    userConsentCookie = props.userConsentCookie;
  var enabled = googleAd.enabled;
  var platform = segmentation.platform;
  var adIsEnabled = !!enabled;
  var classNameContainer = classNames('banner', className, {
    'banner--hidden': !stateAd.show,
    loaded: stateAd.loaded
  });
  var frameClassName = classNames('banner__frame-container', className);
  var observerAd = useRef();
  var observerTrack = useRef();
  var stateRef = useRef(stateAd);
  var updateState = function updateState(newState) {
    stateRef.current = newState;
    setStateAd(newState);
  };
  if (segmentation.mediaFile === 'video' && segmentation.platform === 'webmobile') {
    var navigator = Global.navigator;
    if (getIsLowEndExperience(navigator)) {
      segmentation.mediaFile = '';
    }
  }
  var handleStateAd = function handleStateAd(e) {
    if (!stateRef.current.loaded) {
      if (!e.isEmpty && onAdLoad) {
        onAdLoad();
      }
      updateState({
        show: !e.isEmpty,
        loaded: !e.isEmpty
      });
    }
  };
  useEffect(function () {
    var viewportMargin = props.viewportMargin,
      melidataTrack = props.melidataTrack;
    if (adIsEnabled) {
      if (viewportMargin !== null) {
        if (!isLoadedAdCard) {
          setIsLoadedAdCard(true);
          observerAd.current = getAdServerObserver(platform, viewportMargin, slotId, googleAd, handleStateAd, segmentation, personalDataAdsDenied, userConsentCookie);
        }
        viewPortInterceptionObserver(viewportNode, observerAd.current);
      } else {
        loadGptScript();
        loadAdCard(slotId, googleAd, handleStateAd, segmentation, personalDataAdsDenied, userConsentCookie);
      }
    }
    if (melidataTrack) {
      observerTrack.current = getTrackObserver(melidataTrack);
      trackInterceptionObserver(viewportNode, observerTrack.current);
    }
    return function () {
      var googletag = Global.googletag,
        slot = Global.slot;
      googletag.cmd.push(function () {
        return googletag.destroySlots([slot]);
      });
      disconnectObservers(observerAd.current, observerTrack.current);
    };
  }, []);
  return adIsEnabled ? /*#__PURE__*/_reactJsxRuntime.jsxs(_reactJsxRuntime.Fragment, {
    children: [/*#__PURE__*/_reactJsxRuntime.jsx("div", {
      ref: viewportNode
    }), /*#__PURE__*/_jsx("div", {
      className: classNameContainer
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: frameClassName,
      id: slotId
    }), caption && /*#__PURE__*/_jsx("div", {
      className: "caption"
    }, void 0, caption)), _BannerPreconnectScri || (_BannerPreconnectScri = _BannerPreconnectScri2 || (_BannerPreconnectScri2 = /*#__PURE__*/_jsx(BannerPreconnectScript, {})))]
  }) : /*#__PURE__*/_reactJsxRuntime.jsx("div", {
    ref: viewportNode
  });
};

/**
 * Default props
 */
Banner.defaultProps = {
  className: null,
  googleAd: {},
  segmentation: {},
  caption: null,
  onAdLoad: null,
  viewportMargin: null,
  personalDataAdsDenied: false,
  userConsentCookie: false
};

/**
 * Component propTypes
 */

/**
 * Expose Component
 */
module.exports = Banner;

/**
 * Expose for testing
 */
if (false) {}

/***/ }),

/***/ 444:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _reactJsxRuntime = __webpack_require__(732);
var _jsx = (__webpack_require__(971)["default"]);
var _Fragment, _Fragment2;
/**
 * Module dependencies
 */
var React = __webpack_require__(15);
var Head = __webpack_require__(468);

/**
 * Banner preconnect script
 */
var BannerPreconnectScript = function BannerPreconnectScript() {
  return _Fragment || (_Fragment = _Fragment2 || (_Fragment2 = /*#__PURE__*/_reactJsxRuntime.jsx(_reactJsxRuntime.Fragment, {
    children: /*#__PURE__*/_jsx(Head, {}, void 0, /*#__PURE__*/_jsx("link", {
      rel: "preconnect",
      href: "https://securepubads.g.doubleclick.net"
    }), /*#__PURE__*/_jsx("link", {
      rel: "preconnect",
      href: "https://www.googletagservices.com"
    }))
  })));
};

/**
 * Expose Banner preconnect script
 */
module.exports = BannerPreconnectScript;

/***/ }),

/***/ 649:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(56);
__webpack_require__(199);
__webpack_require__(722);
__webpack_require__(316);
var globalThis = __webpack_require__(907);
var setupDocument = function setupDocument() {
  var document = globalThis.document;
  if (typeof document === 'undefined') {
    document = {
      cookie: ''
    };
  }
  return document;
};
var cookies = {
  set: function set(name, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var document = setupDocument();
    var cookie = "".concat(name, "=");
    if (Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]') {
      cookie = cookie.concat(JSON.stringify(value));
    } else {
      cookie = cookie.concat(value);
    }
    if (options.expires) {
      var date = new Date();
      date.setTime(date.getTime() + 1000 * options.expires);
      cookie = cookie.concat("; Expires=".concat(date.toUTCString()));
    }
    if (options.path) {
      cookie = cookie.concat("; Path=".concat(options.path));
    }
    if (options.domain) {
      cookie = cookie.concat("; Domain=".concat(options.domain));
    }
    if (options.maxAge) {
      cookie = cookie.concat("; Max-Age=".concat(options.maxAge));
    }
    if (options.sameSite) {
      cookie = cookie.concat("; SameSite=".concat(options.sameSite));
    }
    if (options.secure) {
      cookie = cookie.concat('; Secure');
    }
    if (options.httpOnly) {
      cookie = cookie.concat('; HttpOnly');
    }
    document.cookie = cookie;
  },
  get: function get(name) {
    var document = setupDocument();
    var value = '';
    var cookie = document.cookie.split(';').filter(function (item) {
      return item.trim().indexOf(name) === 0;
    });
    if (cookie.length) {
      value = cookie[0].replace("".concat(name, "="), '').trim();
    }
    return value;
  }
};
module.exports = cookies;

/***/ }),

/***/ 907:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(63)["default"]);
/* istanbul ignore file */
if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
  module.exports = window;
} else {
  module.exports = __webpack_require__.g;
}

/***/ }),

/***/ 715:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(63)["default"]);
__webpack_require__(687);
function getHC(navigator) {
  return navigator && navigator.hardwareConcurrency ? navigator.hardwareConcurrency : 0;
}
function getDM(navigator) {
  return navigator && navigator.deviceMemory ? navigator.deviceMemory : 0;
}
function getIsLowEndDevice(navigator) {
  return getHC(navigator) <= 2 || getDM(navigator) <= 2;
}
var getIsLowEndExperience = function getIsLowEndExperience(navigator) {
  var saveData = false;
  var effectiveType = '3g';
  if (navigator) {
    if ('connection' in navigator) {
      var dataConnection = navigator.connection;
      if (_typeof(dataConnection) === 'object') {
        saveData = !!dataConnection.saveData;
        effectiveType = dataConnection.effectiveType;
      }
    }
  }
  if (['slow-2g', '2g', '3g'].includes(effectiveType) || saveData || getIsLowEndDevice(navigator)) {
    return true;
  }
  return false;
};
module.exports = {
  getHC: getHC,
  getDM: getDM,
  getIsLowEndDevice: getIsLowEndDevice,
  getIsLowEndExperience: getIsLowEndExperience
};

/***/ }),

/***/ 190:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Global = __webpack_require__(907);
var settings = function settings(ppid, googletag, iframeTitle) {
  if (ppid) {
    googletag.pubads().setPublisherProvidedId(ppid);
  }
  if (iframeTitle) {
    googletag.setAdIframeTitle(iframeTitle);
  }
  if (!googletag.pubadsReady) {
    googletag.pubads().set('page_url', Global.location.href);
    googletag.pubads().enableSingleRequest();
  }
};
var pubadsReady = function pubadsReady(googletag) {
  if (!googletag.pubadsReady) {
    googletag.pubads().disableInitialLoad();
  }
  if (!googletag.pubadsReady) {
    googletag.enableServices();
  }
};
var pushAd = function pushAd(googletag, unit, size, slotId, noUserSegmentation, personalDataAdsDenied, segmentation, gptadslots, handleStateAd, resolve, userConsentCookie) {
  var slot = googletag.defineSlot(unit, size, slotId);
  noUserSegmentation(personalDataAdsDenied, segmentation, userConsentCookie);
  if (segmentation) {
    Object.keys(segmentation).forEach(function (key) {
      slot.setTargeting(key, [segmentation[key]]);
    });
  }
  slot.addService(googletag.pubads());
  gptadslots.push({
    id: slotId,
    slot: slot
  });
  googletag.display(slotId);
  googletag.pubads().addEventListener('slotRenderEnded', function (e) {
    if (slot.getSlotId().getId() !== e.slot.getSlotId().getId()) return;
    handleStateAd(e);
  });
  Global.slot = slot;
  resolve();
};
module.exports = {
  settings: settings,
  pubadsReady: pubadsReady,
  pushAd: pushAd
};

/***/ }),

/***/ 625:
/***/ ((module) => {

/* global melidata, a */

var TRACK_TYPE = {
  VIEW: 'createViewTrack',
  EVENT: 'createEventTrack'
};
function trackMelidata() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'event' : _ref$type,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? null : _ref$path,
    _ref$event_data = _ref.event_data,
    event_data = _ref$event_data === void 0 ? null : _ref$event_data,
    _ref$experiments = _ref.experiments,
    experiments = _ref$experiments === void 0 ? null : _ref$experiments;
  var track = {};
  if (typeof melidata !== 'function' || !path) {
    return;
  }
  melidata(TRACK_TYPE[type.toUpperCase()], track);
  melidata('withPath', path, track);
  if (event_data) {
    melidata('withData', event_data, track);
  }
  if (experiments) {
    melidata('withExperiments', experiments, track);
  }
  melidata('sendTrack', track);
}
module.exports = {
  trackMelidata: trackMelidata
};

/***/ }),

/***/ 971:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 826:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ }),

/***/ 63:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/typeof");

/***/ }),

/***/ 892:
/***/ ((module) => {

"use strict";
module.exports = require("classnames");

/***/ }),

/***/ 687:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.includes.js");

/***/ }),

/***/ 56:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.json.stringify.js");

/***/ }),

/***/ 900:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.promise.js");

/***/ }),

/***/ 199:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.regexp.exec.js");

/***/ }),

/***/ 722:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.replace.js");

/***/ }),

/***/ 316:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.trim.js");

/***/ }),

/***/ 468:
/***/ ((module) => {

"use strict";
module.exports = require("nordic/head");

/***/ }),

/***/ 15:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 732:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(527);
/******/ 	module.exports.Banner = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=Banner.js.map